import {NgModule, Component, Input, NgZone, ChangeDetectorRef} from "@angular/core";
import {FormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {TranslateModule, TranslateLoader} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {MetadataEditorComponent} from "./metadata.editor.component";
import {QuestionEditorComponent} from "./question.editor.component";
import {QuestionEditorDetailComponent} from "./question.editor.detail.component";
import {GlossaryEditorComponent} from "./glossary.editor.component";
import {GlossaryEditorDetailComponent} from "./glossary.editor.detail.component";
import {VocabularyEditorComponent} from "./vocabulary.editor.component";
import {VocabularyEditorDetailComponent} from "./vocabulary.editor.detail.component";
import {VocabularyEditorMultiDetailComponent} from "./vocabulary.editor.multidetail.component";
import {VerifierEditorComponent} from "./verifier.editor.component";
import {LayoutEditorComponent} from "./layout.editor.component";
import {Tabs} from "./tabs";
import {Tab} from "./tab";
import {PipelineComponent} from "./pipeline.component";
import {PipelineSaveModalComponent} from "./pipeline.save.modal.component";
import {Location, LocationStrategy, PathLocationStrategy} from "@angular/common";
import {RaVersion} from "../services/configuration/ra.version";
import {HttpClient, HttpClientModule} from "@angular/common/http";
import {QuestionReportModalComponent} from "./question.report.modal.component";
import {PipelineScriptModalComponent} from "./pipeline.batch.modal.component";
import {NgSelectModule} from "@ng-select/ng-select";

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, "i18n/", ".json" + RaVersion.full);
}

@NgModule({
    exports: [PipelineComponent, PipelineSaveModalComponent],
  providers: [
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    },
    Location
  ],
    imports: [
        FormsModule,
        CommonModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        NgSelectModule
    ],
  declarations: [
    PipelineComponent,
    PipelineSaveModalComponent,
    MetadataEditorComponent,
    QuestionEditorComponent,
    QuestionEditorDetailComponent,
    GlossaryEditorComponent,
    GlossaryEditorDetailComponent,
    VocabularyEditorComponent,
    VocabularyEditorDetailComponent,
    VocabularyEditorMultiDetailComponent,
    VerifierEditorComponent,
    LayoutEditorComponent,
    Tabs,
    Tab]

})
export class PipelineModule {
}
